import Alpine from "alpinejs";

window.getCornerColor = (img, corner) => {
	// Create a canvas element
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");
	canvas.width = img.width;
	canvas.height = img.height;

	// Draw the image onto the canvas
	ctx.drawImage(img, 0, 0);

	// Define corner coordinates
	let x, y;
	switch (corner) {
		case "top-left":
			x = 2;
			y = 2;
			break;
		case "top-right":
			x = img.width - 2;
			y = 2;
			break;
		case "bottom-left":
			x = 2;
			y = img.height - 2;
			break;
		case "bottom-right":
			x = img.width - 2;
			y = img.height - 2;
			break;
		default:
			x = 2;
			y = 2;
			break;
	}

	// Get the pixel data in the specified corner
	const pixelData = ctx.getImageData(x, y, 1, 1).data;

	// Extract RGB values
	const r = pixelData[0];
	const g = pixelData[1];
	const b = pixelData[2];

	// Return the color as an RGB string
	return `rgb(${r}, ${g}, ${b})`;
};

// Setup Alpine prefix.
Alpine.prefix("xdigital-");
window.Alpine = Alpine;

Alpine.start();

const handleNavScrollForLink = (navMainLink: Element) => {
	if (!navMainLink || navMainLink.length === 0) {
		return;
	}
	const programBladContent = document.querySelector(".programblad-content");
	if (!programBladContent) {
		return;
	}
	navMainLink.forEach((link) => {
		link.addEventListener("click", (event) => {
			event.preventDefault();
			programBladContent.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});
	});
};

const handleMenuScroll = (navElements: NodeListOf<Element>) => {
	const isJcore = !!document.querySelector("#jcore-body");

	if (!navElements || navElements.length === 0) {
		return;
	}
	const hamburgerEl = document.querySelector(
		isJcore ? "#mobile-menu-toggle" : ".hamburger",
	);
	navElements.forEach((navElement) => {
		navElement.addEventListener("click", (event) => {
			hamburgerEl?.click();
		});
	});
};

const handleNavScroll = () => {
	const isJcore = !!document.querySelector("#jcore-body");
	const navMainLink = document.querySelectorAll(
		isJcore ? ".navbar-mobile-main > a" : ".brand > a",
	);
	handleNavScrollForLink(navMainLink);
	const navElements = document.querySelectorAll(
		isJcore ? "#mobile-menu li > a" : ".primary-nav a",
	);
	handleMenuScroll(navElements);
};

const handleStickyHeader = () => {
	let scrollUpOffset = 0;
	let scrollDownOffset = 0;

	const isJcore = !!document.querySelector("#jcore-body");

	const scrollElement = document.querySelector(".programblad-content");
	const siteHeader = document.querySelector(
		isJcore ? "#mobile-navbar" : ".site-header",
	);

	scrollElement.addEventListener("scroll", (e) => {
		const scrolledFromTop = e.target.scrollTop;

		if (scrolledFromTop < 100) {
			siteHeader.classList.add("scrollTop");
			siteHeader.classList.remove("scroll-up");
			siteHeader.classList.remove("scroll-down");
			return;
		} else {
			siteHeader.classList.remove("scrollTop");
		}

		if (scrolledFromTop > scrollUpOffset) {
			siteHeader.classList.add("scroll-down");
			siteHeader.classList.remove("scroll-up");
		} else if (scrolledFromTop < scrollDownOffset) {
			siteHeader.classList.remove("scroll-down");
			siteHeader.classList.add("scroll-up");
		}

		scrollUpOffset = scrolledFromTop;
		scrollDownOffset = scrolledFromTop;
	});
};

const setupToggle = function (parentElement) {
	const toggleElement = parentElement.querySelector(".show-more-button");
	const openText = parentElement.querySelector(".open-text");
	const closeText = parentElement.querySelector(".close-text");
	if (!toggleElement) return;
	toggleElement.addEventListener("click", () => {
		parentElement.classList.toggle("show-all");
		parentElement.scrollIntoView({
			behavior: "smooth",
		});
		if (parentElement.classList.contains("show-all")) {
			openText.style.display = "none";
			closeText.style.display = "block";
		} else {
			openText.style.display = "block";
			closeText.style.display = "none";
		}
	});
};

const handleWrappers = () => {
	const wrapperElements = document.querySelectorAll(
		".wp-block-digitalt-programblad-wrapper",
	);
	wrapperElements.forEach((wrapperElement) => {
		if (!wrapperElement.querySelector(".show-more-button")) {
			return;
		}
		setupToggle(wrapperElement);
	});
};
document.addEventListener("DOMContentLoaded", () => {
	if (!document.querySelector(".single-programblad")) {
		return;
	}
	handleNavScroll();
	handleStickyHeader();
	handleWrappers();
});
